export function showRangeScale(evt, input) {
    evt.preventDefault();
    evt.target.closest('.range').classList.add('active');
    input.closest('.form-field').classList.add('none');
}
